import { object } from './type-checkers.js';
import { wrapType } from './util.js';
/**
 * A property that extends an already existing component, allowing more fine-grained control
 * for properties used to control components within components.
 *
 * @param component - The name of the component being extended;
 * @param displayProps - The props displayed as a preview of the extended object;
 * @param hiddenProps - Props that shouldn't be available for extension.
 */
function extendComponent(componentName, displayProps, hiddenProps) {
    return wrapType(object, { componentName, displayProps, hiddenProps, type: 'extend-component' });
}
export { extendComponent, };
//# sourceMappingURL=extend-component.js.map